import React from "react";
import '../../shared/screen.css';
export default function About() {
    return <div className="container">
    <h1>Welcome to Calmli!</h1>
      <p>Life can get pretty stressful, right? Especially lately, with lots of anxiety around. I get it – it's tough to focus on work or study when everything feels overwhelming.</p>
      <p>I found something that helped me a lot – chill music and nature sounds. They're like a cozy blanket for your ears. They helped me relax and concentrate, drowning out all the noisy thoughts.</p>
      <p>So, I made this music player for you. It's not just about playing songs – it's about making your own special mix. Need something chill? Or something to help you focus? You're in charge here.</p>
      <p>Explore our collection, mix different sounds, and create your own background music for any moment. It's like your own personal playlist for finding peace in the middle of chaos.</p>
      <p>Welcome to our music player. Let's calm things down together.</p>
    </div>
}